export default {
  sellingPricesAboveCost: null,
  sellingPricesAboveCosts: [],
  contacts: [],
  lines: [],
  brands: [],
  params_contacts: {
    filter: "",
    type: "is_customer",
    paginate: false
  },
  params: {
    client: null,
    line: null,
    brand: null,
    percentage: null
  }
};



// WEBPACK FOOTER //
// ./src/modules/selling-prices-above-cost/state.js